import { LegalPage } from '../components/LegalPage';

const AMLPolicyPage = () => <LegalPage doc="aml" testId="aml-policy-page" />;

export default AMLPolicyPage;
